var Iframe_default = {
  "iframe": "_4lKTZ"
};
export {
  Iframe_default as default
};
//# sourceMappingURL=Iframe-scss.js.map
